import moment from 'moment';
import React, {Component} from 'react'
// import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Legend, Tooltip } from 'chart.js';
import { Bar } from 'react-chartjs-2';
// import ChartDataLabels from 'chartjs-plugin-datalabels';
import calculateRatio from '../../helpers/calculateRatio';

// Đăng ký các component cần thiết cho ChartJS
// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   LineElement,
//   PointElement,
//   Legend,
//   Tooltip,
//   ChartDataLabels
// );

class ChartReport extends Component {
    render() {
        const {data, typeReport, periodType, dataLabels} = this.props

        const datasets = [
            {
                type: 'bar',
                label: typeReport === 'customer_service' ? 'Tổng số lượng item bị claim lỗi' : typeReport === 'process_quality' ? 'Tổng số lượng item lỗi' : 'Tổng số lượng item được đóng thùng',
                data: data.map(item => item.totalX),
                backgroundColor: 'rgba(161, 148, 255, 0.7)',
                borderColor: 'rgba(161, 148, 255, 1)',
                borderWidth: 1
            },
            {
                type: 'bar',
                label: typeReport === 'customer_service' ? 'Tổng số lượng item được đóng thùng' : typeReport === 'process_quality' ? 'Tổng số item được đóng thùng trong khoảng thời gian đó' : 'Tổng số lượng item đẩy xưởng',
                data: data.map(item => item.totalY),
                backgroundColor: 'rgba(255, 168, 161, 0.7)',
                borderColor: 'rgba(255, 168, 161, 1)',
                borderWidth: 1
            }
        ]

        if(!(typeReport === 'product_results' && periodType === '1D')){
            const datasetsRatio = {
                type: 'line',
                label: typeReport === 'customer_service' ? 'Tỉ lệ bị claim ' : typeReport === 'process_quality' ? 'Tỉ lệ lỗi' : 'Tỉ lệ sản xuất',
                data: data.map(item => calculateRatio(item.totalX, item.totalY)),
                borderColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
                fill: false,
                lineTension: 0.3,
                yAxisID: 'y-axis-2', // dùng trục Y phụ cho line chart nếu muốn
                datalabels: {
                    display: false, // 👈 Ẩn cho Line
                },
            }

            datasets.push(datasetsRatio)
        }
        
        const dataChart = {
            labels: dataLabels,
            datasets: datasets
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                datalabels: {
                    display: true,
                    color: "black",
                    anchor: "end",
                    align: "start",
                    formatter: (value) => `${value}`,
                    rotation: 90,
                    font: {
                        weight: "bold",
                        size: 12,
                    },
                },
            },
            legend: {
                position: 'bottom'
            },
            scales: {
                xAxes: [{
                    // barThickness: 30,
                    // categoryPercentage: 1.0,
                    // barPercentage: 1.0,
                    ticks: {
                        autoSkip: false
                    },
                    gridLines: {
                        display: false
                    }
                }],
                yAxes: [
                    {
                        id: 'y-axis-1',
                        position: 'left',
                        ticks: {
                            beginAtZero: true
                        }
                    },
                    {
                        id: 'y-axis-2',
                        position: 'right',
                        ticks: {
                            beginAtZero: true,
                            callback: function (value) {
                                return `${value}%`; // chuyển sang phần trăm
                            },
                        },
                        gridLines: {
                            drawOnChartArea: false
                        }
                    }
                ]
            },
            tooltips: {
            mode: 'index',
            intersect: false
            }
        };

        return (
            <div className='ChartReport'>
                <div style={{ width: '100%', height: '600px' }}>
                    <Bar data={dataChart} options={options}/>
                </div>
            </div>
        )
    }
}

export default ChartReport
